import { render, staticRenderFns } from "./BoardsTourPage.vue?vue&type=template&id=33be0686&scoped=true"
import script from "./BoardsTourPage.vue?vue&type=script&lang=ts"
export * from "./BoardsTourPage.vue?vue&type=script&lang=ts"
import style0 from "./BoardsTourPage.vue?vue&type=style&index=0&id=33be0686&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33be0686",
  null
  
)

export default component.exports